module.exports = __webpack_public_path__ + "static/images/qb-coupon.54e34a3.png";